import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { Box, Button, Grid, Typography } from '@mui/material';

import DisputeActionOptions from '../DisputeActionOptions';
import {
  BIDDER_SUCCESS_MESSAGES,
  DISPUTES_ACTIONS,
  getSubmitDisputeError,
  getSubmitDisputesFlags,
  VIEW_DISPUTE_URL
} from '../utils';
import { confirmSendDisputeMessage, fetchSingleDispute } from '../../../../modules/disputes/thunks';
import {
  CLOSE_SINGLE_DISPUTE,
  SUBMIT_DISPUTE_SUCCESS_MESSAGE
} from '../../../../modules/disputes/reducer';
import TermAndConditionPopUp from '../TermAndConditionPopUp';

const Actions = ({ dispute, isOpenDispute }) => {
  const { disputeRef } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const messageRef = useRef('');
  const disputeId = dispute.disputeInfo?.disputeID || '';

  const { houseRef, disputeTermsAccepted } = useSelector(store => store.house) || {};
  const user = useSelector(store => store.user) || {};

  const isSuperUser = user.isSuperUser !== null;

  const [action, setSelectAction] = useState(
    !isOpenDispute && isSuperUser ? DISPUTES_ACTIONS.REOPEN : DISPUTES_ACTIONS.SEND
  );
  const [disputeError, setDisputeError] = useState('');
  const [sendMessageLoading, setSendMessageLoading] = useState(false);
  const [openTermsAndConditionModal, setOpenTermsAndConditionModal] = useState(false);
  const [shouldAcceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);

  const showReOpenOption = !isOpenDispute && isSuperUser;
  const showActions = showReOpenOption || isOpenDispute;
  const submitActionHandler = disputeTermsAccepted => {
    const isActionSend = action === DISPUTES_ACTIONS.SEND;
    const message = isActionSend ? messageRef.current.value : '';
    const flags = getSubmitDisputesFlags([dispute], [disputeId]);
    const error = getSubmitDisputeError({
      flags,
      isSuperUser,
      selectAction: action,
      sendMessage: message
    });

    if (error) {
      setDisputeError(error);
    } else if (isActionSend && !message) {
      setDisputeError('Message is required.');
    } else if (action === DISPUTES_ACTIONS.CLOSE && !isSuperUser && !disputeTermsAccepted) {
      setAcceptTermsAndConditions(true);
      setOpenTermsAndConditionModal(true);
    } else {
      setDisputeError('');
      setSendMessageLoading(true);
      dispatch(
        confirmSendDisputeMessage(
          houseRef,
          {
            action,
            message,
            disputeIDs: [disputeId],
            houseUserRef: user.userRef
          },
          () => {
            if (action === DISPUTES_ACTIONS.REOPEN) {
              dispatch(
                fetchSingleDispute(houseRef, disputeRef, () => {
                  setSendMessageLoading(false);
                })
              );
            } else {
              if (isActionSend) messageRef.current.value = '';
              else dispatch({ type: CLOSE_SINGLE_DISPUTE });
              setSendMessageLoading(false);
            }
            dispatch({
              type: SUBMIT_DISPUTE_SUCCESS_MESSAGE,
              payload: BIDDER_SUCCESS_MESSAGES[action]
            });
          }
        )
      );
    }
  };

  return (
    <Grid mt={3}>
      {showActions && (
        <DisputeActionOptions
          ref={messageRef}
          selectAction={action}
          setSelectAction={setSelectAction}
          showReOpenOption={showReOpenOption}
          showMessageOption={isOpenDispute}
          openTermsAndConditions={() => setOpenTermsAndConditionModal(true)}
          showCloseAndCancelOption
        />
      )}
      {showActions ? (
        <Box mt={3} mb={4}>
          <Button
            disabled={sendMessageLoading}
            className="submit-action"
            variant="contained"
            onClick={() => submitActionHandler(disputeTermsAccepted)}
          >
            Submit Action
            {sendMessageLoading && (
              <ReactLoading className="ml-1" type="spin" height="auto" width={15} />
            )}
          </Button>
          <Button
            sx={{ marginLeft: '20px' }}
            className="cancel-action"
            onClick={() => {
              history.push(VIEW_DISPUTE_URL);
            }}
          >
            Cancel
          </Button>
          {disputeError && (
            <Typography variant="body2" color="red" mt={2}>
              {disputeError}
            </Typography>
          )}
          <TermAndConditionPopUp
            open={openTermsAndConditionModal}
            closeModal={() => setOpenTermsAndConditionModal(false)}
            onContinue={() => submitActionHandler(true)}
            shouldAcceptTermsAndConditions={shouldAcceptTermsAndConditions}
          />
        </Box>
      ) : (
        <Button
          className="submit-action"
          variant="contained"
          onClick={() => {
            history.push(VIEW_DISPUTE_URL);
          }}
        >
          Go Back
        </Button>
      )}
    </Grid>
  );
};

export default Actions;
